import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    fieldDisabled: translate({ id: 'order.form.bulk.loads.fieldDisabled.tooltip' }),
    addLoad: translate({ id: 'order.form.bulk.loads.addLoadsModalTitle' }),
    addLoadTooltip: (disableReason: 'noLoads' | 'limitReached' | undefined, maxLoads: number) => {
      switch (disableReason) {
        case 'noLoads':
          return translate({ id: 'order.form.bulk.loads.addLoadsTooltip.noLoads' })
        case 'limitReached':
          return translate({
            id: 'order.form.bulk.loads.addLoad.disabled.tooltip',
            values: { maxLoads },
          })
        default:
          return translate({ id: 'order.form.bulk.loads.addLoadsTooltip' })
      }
    },
    newLoadWarningHeader: translate({ id: 'orders.edit.validation.loads.newLoadWarningHeader' }),
    newLoadWarningContent: translate({ id: 'orders.edit.validation.loads.newLoadWarning' }),
  }))

  return api
}
